import React, { useEffect, useState } from 'react';
import { Text } from '@heartinternet/hi-ui';

const PAYPAL_BUTTON_URL = '/manage/paypal-button.cgi';

interface PaypalButtonProps {
  productId: number;
}

/**
 * Mirrors the legacy `ppb()` behaviour: fetch the PayPal Buy-Now button fragment
 * for this product and inject it. The fragment is PayPal's encrypted <form>,
 * returned as text/plain by our own CGI — there is no hi-ui equivalent, so this
 * is a deliberate `dangerouslySetInnerHTML` fallback. On failure or empty
 * response we render nothing (legacy clears the cell).
 */
export const PaypalButton: React.FC<PaypalButtonProps> = ({ productId }) => {
  const [html, setHtml] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    fetch(`${PAYPAL_BUTTON_URL}?pid=${encodeURIComponent(String(productId))}`, {
      credentials: 'same-origin',
    })
      .then((res) => (res.ok ? res.text() : Promise.reject(new Error(String(res.status)))))
      .then((text) => {
        if (text && text.trim().length > 0) setHtml(text);
        else setFailed(true);
      })
      .catch(() => setFailed(true));
  }, [productId]);

  if (failed) return null;
  if (html === null) {
    return (
      <Text
        variant="caption"
        color="muted"
        className="hi-ui-order-domain-credits-page__paypal-loading"
      >
        Checking PayPal&hellip;
      </Text>
    );
  }
  return (
    <div
      className="hi-ui-order-domain-credits-page__paypal"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
